export default function getCompareScrollingMargin(state) {
  return state.comparePageScrolling;
}
